import Project from "../project"
import {toMomentDate} from "../../../gd/convert/moment-date"

export type UpdateDateOptions = {
    keepCalendarDuration?   : boolean
}

export default function projectUpdateStartDate(project:Project, startDate:Moment|null, options:UpdateDateOptions={}) {
    let endStartDiff : number|undefined = undefined

    if (options.keepCalendarDuration && project.startDate && project.endDate) {
        endStartDiff = moment(project.endDate).diff(moment(project.startDate), 'days')
    }

    project.startDate = toMomentDate(startDate)

    // if we set start date to null, end date should be null too
    if (startDate === null) {
        project.endDate = null
    }

    if (project.startDate && !project.endDate) {
        project.endDate = toMomentDate(project.startDate)
    }

    // if endDate BEFORE start set start = end because we update START here
    if (project.startDate && project.endDate && project.endDate.isBefore(project.startDate,'days')) {
        project.endDate = toMomentDate(project.startDate)
    }

    if (options.keepCalendarDuration && project.startDate && endStartDiff!==undefined) {
        project.endDate    = moment(project.startDate).add(endStartDiff,'days')
    }
}